(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        $(function () {
            var UNDEFINED = -1;
            /**
             * @type {number}
             */
            var SHOW_QUIZ_IN_MS = window.app.hasOwnProperty('quizCountdownMs') ? window.app.quizCountdownMs : UNDEFINED;
            // название куки
            var COOKIE_NAME = 'quiz_revealed_v2';
            // оригинальный виджет
            var $quizWidget = $('#quiz-widget');
            // оригинальная форма
            var $quizForm = $quizWidget.find('.quiz-form');
            // всего стадий
            var STAGE_COUNT = $quizForm.find('.quiz-group').length;
            // текущая стадия
            var currentStage = 0;
            // режим отладки
            var isDebug = !!$quizForm.data('debug');
            $quizForm.removeAttr('data-debug');
            // форма успешно отправилась, больше не надо
            var isFormSubmitted = false;

            if (window.app.debug) {
                console.log('The quiz form will be shown in', SHOW_QUIZ_IN_MS, 'ms,', 'now is', new Date().toLocaleTimeString());
            }

            var allowShowQuiz = SHOW_QUIZ_IN_MS !== UNDEFINED && !window.utils.cookies.get(COOKIE_NAME);

            // получить контейнер квиза
            function getTheQuiz() {
                return $('#bspopup .the-quiz');
            }

            // инициализация
            function init() {
                // применить маску
                getTheQuiz().find('[data-mask]').each(function (i, e) {
                    var $elem = $(e);
                    $elem.mask($elem.data('mask'), {
                        placeholder: '_'
                    });
                });

                // инициализировать первую стадию
                gotoNext();
            }

            // валидация каждой стадии
            function validateStage(stage) {
                var $currentGroup = getTheQuiz().find('.quiz-group').filter('.current');

                switch (stage) {
                    case 0:
                        return true;
                    case 1:
                        // выбрана хотя бы одна страна
                        var isAnyCountrySelected = $currentGroup.find('[data-attr="countries"]:checked').length > 0;
                        // заполнено поле "Другое"
                        var isCustomCountryFilled = $currentGroup.find('[data-attr="customCountries"]').val().trim().length > 0;
                        // чекнута галка "Другое"
                        var isCustomCountryChecked = $currentGroup.find('[data-role="customCountries"]').is(':checked');

                        return isAnyCountrySelected || isCustomCountryChecked && isCustomCountryFilled;
                    case 2:
                        // выбран хотя бы один период
                        return $currentGroup.find('[data-attr="periods"]:checked').length > 0;
                    case 3:
                        // указан номер телефона
                        return $currentGroup.find('[data-attr="phone"]').val().length > 0;
                    default:
                        return false;
                }
            }

            // переход к стадии № stage
            function gotoStage(stage) {
                var $theQuiz = getTheQuiz();
                // контейнеры контролов, сгруппированые по стадиям
                var $quizGroups = $theQuiz.find('.quiz-group');
                // скрыть все
                $quizGroups.removeClass('current');
                if (STAGE_COUNT <= 0 || stage > STAGE_COUNT) {
                    return;
                }
                // показать текущую
                $quizGroups.eq(stage - 1).addClass('current');
                // показать проресс в индикаторе
                var $progressButton = $theQuiz.find('[data-role="progress"]');
                $progressButton.find('.progress-indicator').text("(" + stage + "/" + STAGE_COUNT + ")");
                $progressButton.find('.progress-caption').text(stage < STAGE_COUNT ? 'Далее' : 'Готово');
            }

            // переход к следующей стадии
            function gotoNext() {
                // валидировать текущую стадию
                if (!validateStage(currentStage)) {
                    return;
                }
                gotoStage(++currentStage);
            }

            // переход к финальной информационной стадии
            function gotoEnd() {
                var $theQuiz = getTheQuiz();
                // валидировать последнюю стадию перед финальной инофрмационной
                if (!validateStage(STAGE_COUNT)) {
                    return;
                }
                // сабмит формы
                $theQuiz.find('.quiz-form').trigger('submit');
            }

            // логировать при отладке
            function log() {
                var _console;

                if (!isDebug) {
                    return;
                }
                (_console = console).log.apply(_console, arguments);
            }

            // очистить текст с ошибкой
            function clearFeedback() {
                getTheQuiz().find('.quiz-feedback').removeClass('text-error').text('');
            }

            // заморозить форму
            function onFormFreeze() {
                getTheQuiz()
                // loading...
                .addClass('pending')
                // disable button
                .find('.quiz-button').attr('disabled', true);
            }

            // разморозить форму
            function onFormUnfreeze() {
                getTheQuiz()
                // loaded
                .removeClass('pending')
                // disable button
                .find('.quiz-button').removeAttr('disabled');
            }

            // показать ошибку сабмита формы
            function onFormSubmitError(txtError) {
                getTheQuiz().find('.quiz-feedback').addClass('text-error').text(txtError);
            }

            // показать успех сабмита формы
            function onFormSubmitSuccess() {
                // показать успешный экран, когда всё хорошо
                getTheQuiz().addClass('done');
            }

            function isAnyPopupShown() {
                return $('.modal.in').length > 0; // some modal is visible now
            }

            // показать форму квиза
            function showQuiz() {
                if (!allowShowQuiz || isAnyPopupShown()) {
                    return;
                }
                allowShowQuiz = false;
                // конфигурировать модалку
                bs3popup({
                    content: $quizWidget.html(),
                    getLock: true,
                    setLock: true,
                    onAfterShow: function onAfterShow() {
                        // переустановить куку на исходное к-во дней
                        var days = 1;
                        window.utils.cookies.set(COOKIE_NAME, 1, { expires: days * 24 * 60 * 60, path: '/' });
                    }
                });

                // инициализировать
                init();

                // показать в модалке
                bs3popup('show');
            }

            if (allowShowQuiz) {
                setTimeout(showQuiz, SHOW_QUIZ_IN_MS);
            }

            $('#bspopup')
            // перейти к следующей стадии
            .on('click', '.the-quiz [data-role="progress"]', function () {
                $(this).blur();
                if (currentStage < STAGE_COUNT) {
                    // переход к следующей стадии
                    gotoNext();
                } else {
                    // показать финальную информационную стадию
                    gotoEnd();
                }
            })
            // закрыть модалку с завершающей успешной стадии
            .on('click', '.the-quiz [data-role="complete"]', function () {
                if (currentStage < STAGE_COUNT) {
                    return;
                }
                // скрыть модалку
                bs3popup('hide');
            })
            // показать/скрыть поле "Другое"
            .on('click', '.the-quiz [data-role="customCountries"]', function () {
                getTheQuiz().find('[data-attr="customCountries"]').closest('.quiz-control').toggleClass('invisible', !$(this).is(':checked'));
            }).on('submit', '.quiz-form', function (e) {
                e.preventDefault();

                var $self = $(this);
                if (!$self.closest('#bspopup').length || isFormSubmitted) {
                    // если форма не в модалке (или уже отправилась), то запрет сабмита
                    return false;
                }

                // если галка "Другое" снята, то не передавать на сервер соответствующее текстовое поле
                if (!$self.find('[data-role="customCountries"]').is(':checked')) {
                    $self.find('[data-attr="customCountries"]').val('');
                }

                // отправка данных формы
                $.ajax(this.action, {
                    method: this.method,
                    data: $self.serialize(),
                    beforeSend: function beforeSend(jqXHR, settings) {
                        // заморозить форму
                        onFormFreeze();
                        // сбросить текст с ошибкой
                        clearFeedback();
                    },
                    error: function error(jqXHR, textStatus, errorThrown) {
                        log("Status: \"" + textStatus + "\". Error: \"" + errorThrown + "\".");

                        // показать ошибку сабмита формы
                        onFormSubmitError(errorThrown);
                    },
                    success: function success(data) {
                        data = data || {};
                        log('Data:', data);

                        if (data.success) {
                            isFormSubmitted = true;

                            // показать успех сабмита формы
                            onFormSubmitSuccess();
                            // сбросить текст с ошибкой
                            clearFeedback();
                        } else {
                            // показать ошибку сабмита формы
                            onFormSubmitError(data.message || 'Ошибка, попробуйте позже');
                        }

                        window.tracking.setEvent('tour-quiz-form.submit');
                    },
                    complete: function complete(jqXHR, textStatus) {
                        // разморозить форму
                        onFormUnfreeze();
                    }
                });

                return false;
            });
        });
    }, {}] }, {}, [1]);